import type { SecuritySettingsFeatureConfig } from '../type';

export const securitySettingsConfig: Partial<SecuritySettingsFeatureConfig> = {
    alternateExternalClientId: '2af44bd6-c28d-4fa2-99fb-33451160ff4b',
    externalTargets: ['methods', 'password'],
};
